"use strict";
import DOMPurify from "dompurify";
import "./components";
import { ConditionalFormHandling } from "../src/conditional_form_handling";
import { DependentDropdownHandling } from "../src/dependent_dropdown_handling";
import InquiryFormDocumentUploads from "../src/inquiry_form_document_uploads";
import FormBuilderV2 from "../src/form_builder_v2_helpers";
import { modifyEmailHtmlForPreview, writeToPreviewIframe } from "../src/email_html_modifier";
import $ from "jquery";
import "jquery-migrate";
import("../src/patches/jquery_patch");
import DataTable from "datatables.net";
window.DOMPurify = DOMPurify;
window.modifyEmailHtmlForPreview = modifyEmailHtmlForPreview;
window.writeToPreviewIframe = writeToPreviewIframe;
window.ConditionalFormHandling = ConditionalFormHandling;
window.DependentDropdownHandling = DependentDropdownHandling;
window.InquiryFormDocumentUploads = InquiryFormDocumentUploads;
window.FormBuilderV2 = FormBuilderV2;
window.ViGridHelper2 = {
  reload: function(gridId) {
    var grid = this.grids[gridId] || document.getElementById(gridId);
    if (grid && typeof grid.reload === "function") grid.reload();
  },
  grids: {}
};
window.$ = $;
window.jQuery = $;
DataTable.defaults.column.orderSequence = ["asc", "desc"];
